import { AfterViewInit, Component, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatSidenav, MatSidenavContainer, MatSidenavContent} from '@angular/material/sidenav';

import {MatIcon} from '@angular/material/icon';
import {SidenavService} from '../../../pages/dashboard/utils/sidenav.service';
import { RouterLink } from '@angular/router';
import { MatIconButton } from '@angular/material/button';

@Component({
  selector: 'app-side-nav',
  imports: [CommonModule, MatSidenav, MatSidenavContainer, MatSidenavContent, MatIcon, RouterLink, MatIconButton],
  templateUrl: './side-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './side-nav.component.css',
})
export class SideNavComponent implements AfterViewInit {
  private sidenavService = inject(SidenavService);

  @ViewChild('snav') public sidenav!: MatSidenav;

  ngAfterViewInit(): void {
    this.sidenavService.setSidenav(this.sidenav);
  }

  close(): void {
    this.sidenavService.close();
  }

  isDropdownOpen = false;

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
  }
}

